module.exports = __webpack_public_path__ + "static/media/login-bg.f0efb7fd.svg";